'use strict';

var react = require('@emotion/react');
var zIndex = require('../../../../constants/zIndex.cjs');

const price = /*#__PURE__*/ react.css({
    marginTop: "auto",
    paddingBottom: "4px",
    position: "relative",
    zIndex: zIndex.cardAction
}, "label:label-Price-web-stylesprice", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL3BsYXRmb3JtL1Byb2R1Y3RDYXJkL1ByaWNlL1ByaWNlLndlYi5zdHlsZXMudHMiLCJzb3VyY2VzIjpbIi9idWlsZHMvZGV2ZWxvcGVycy9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9wbGF0Zm9ybS9Qcm9kdWN0Q2FyZC9QcmljZS9QcmljZS53ZWIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5pbXBvcnQgeyB6SW5kZXggfSBmcm9tIFwiI2NvbnN0YW50c1wiO1xuXG5leHBvcnQgY29uc3QgcHJpY2UgPSBjc3Moe1xuICBtYXJnaW5Ub3A6IFwiYXV0b1wiLFxuICBwYWRkaW5nQm90dG9tOiBcIjRweFwiLFxuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICB6SW5kZXg6IHpJbmRleC5jYXJkQWN0aW9uLFxufSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXFCIn0= */");

exports.price = price;
//# sourceMappingURL=Price.web.styles.cjs.map
